import { createContext } from 'react'

export const ApiContext = createContext<string | null>(null)
